import React from 'react';
import SubjectPage from '../../subjects/SubjectPage';

function ErrorLessBook() {

  const pageTitleText = "Errorless Biology Book";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="errorless-book" 
        type="errorlessbook"
      />

    </>
  );
}

export default ErrorLessBook;